module.exports = __webpack_public_path__ + "media/images/logo-shield-4d58671310d6ff28232492d9e9203f71.svg";